//
//
//
//
//
//
//
//
//

	import configInfo from "../configInfo.js"

	export default{
		data(){
			return{
				closeTag: require('../assets/img/close.svg'),
				backgroundImg: require('../assets/img/advertisement.png'),
				isAdvertisementShow: configInfo.isAdvertisementShow
			}
		},
		methods:{
			afterClose(){
				configInfo.isAdvertisementShow = false;
				this.isAdvertisementShow = configInfo.isAdvertisementShow;
				this.$emit('afterClose');
			}
		}
	}



// WEBPACK FOOTER //
// ./src/views/advertisement.vue